import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "nav-activity-center__label"
};
export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createBlock(_component_router_link, {
    to: {
      name: 'ActivityCenter'
    },
    class: "nav-activity-center",
    "aria-label": _ctx.$t('nav.activityCenterAria')
  }, {
    default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("span", {
      class: "nav-activity-center__glow",
      "aria-hidden": "true"
    }, null, -1)), _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "nav-activity-center__icon",
      "aria-hidden": "true"
    }, "✦", -1)), _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('nav.activityCenterLabel')), 1)]),
    _: 1
  }, 8, ["aria-label"]);
}